var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4668 16.4067H15.0332L15.5059 6.40674H5.99414L6.4668 16.4067Z",
    fill: "#FFE6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 5.00049H15.125V3.43799C15.125 2.74854 14.5645 2.18799 13.875 2.18799H7.625C6.93555 2.18799 6.375 2.74854 6.375 3.43799V5.00049H3.875C3.5293 5.00049 3.25 5.27979 3.25 5.62549V6.25049C3.25 6.33643 3.32031 6.40674 3.40625 6.40674H4.58594L5.06836 16.6216C5.09961 17.2876 5.65039 17.813 6.31641 17.813H15.1836C15.8516 17.813 16.4004 17.2896 16.4316 16.6216L16.9141 6.40674H18.0938C18.1797 6.40674 18.25 6.33643 18.25 6.25049V5.62549C18.25 5.27979 17.9707 5.00049 17.625 5.00049ZM7.78125 3.59424H13.7188V5.00049H7.78125V3.59424ZM15.0332 16.4067H6.4668L5.99414 6.40674H15.5059L15.0332 16.4067Z",
    fill: "#F5222D",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.a33c4a71bef80c80d59f25e99c721d26.svg";
export { ForwardRef as ReactComponent };